import Vue from "vue";
import App from "./App.vue";
import "./plugins/axios";
import ApiRoutes from "./utils/routes/apiRoutes";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import swal from "sweetalert";
import Swal2 from "sweetalert2";
import moment from "moment";

window.$ = require('jquery');
Vue.component('AccountMonthlySearch', require('./components/accounts/AccountMonthlySearch.vue').default);
window.Swal2 = Swal2;
window.Toast = Swal2.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal2.stopTimer);
        toast.addEventListener("mouseleave", Swal2.resumeTimer);
    },
});
import "./mixins/global_mixins";
Vue.config.productionTip = false;
window.apiRoutes = ApiRoutes;
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("MMM Do YY");
    }
});

export const bus = new Vue();
new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");